/**
 * The message in a Worker error body. Most routes answer { error: "message" }; routes behind the Worker's guard()
 * (worker/src/authz/guard.js, docs/PERMISSIONS.md) answer { error: { code, message } }. Both read the same here.
 */
export function errorText(body: unknown): string | undefined {
  const e = (body as { error?: unknown } | null | undefined)?.error;
  if (typeof e === "string") return e || undefined;
  const m = (e as { message?: unknown } | null | undefined)?.message;
  return typeof m === "string" && m ? m : undefined;
}
